<template>
  <div class="w-full flex flex-wrap flex-row-reverse justify-between gap-x-3 gap-y-2.5">
    <slot />
  </div>
</template>
